<template>
  <div>
    <div
      class="card card_white flex-fill"
      :class="selected ? 'selected' : ''"
      style="margin-bottom: 8px; cursor: pointer"
      @click="detail(param)"
      v-bind:style="
        height === 308
          ? 'width: 150px; height:' + height + 'px'
          : 'height:' + height + 'px'
      "
    >
      <div class="sub_title_2">
        <span style="text-transform: capitalize" v-if="param.metricName != null"
          >{{ param.metricName }}
          <!-- {{
            param.metricId !== "DISTRIBUTION_NUMBER_OF_INCIDENTS" &&
            param.metricId !== "DISTRIBUTION_NUMBER_OF_FATALITIES" &&
            param.metricId !== "DISTRIBUTION_UNSAFE_ACT" &&
            param.metricId !== "DISTRIBUTION_UNSAFE_CONDITION" &&
            param.metricId !== "DISTRIBUTION_NEAR_MISS"
              ? unit(param.unit)
              : ""
          }} -->
        </span>
      </div>
      <div
        v-if="param.value != null"
        class="data_text"
        :style="height === 308 ? 'width: 130px' : ''"
      >
        {{ formattedNumber(param.value) }} {{ unitShow(param.unit) }}
        {{ param.metricId === "DISTRIBUTION_SALDO_STOK_MATERIAL" ? "Tn" : "" }}
      </div>
      <div
        :class="
          param.metricId === 'DISTRIBUTION_DAFTAR_TUNGGU'
            ? 'm-b-2 mt-1'
            : ' m-b-5  mt-2'
        "
        class="d-flex justify-content-between"
      >
        <div>
          <div
            v-if="
              param.metricId !== 'DISTRIBUTION_NUMBER_OF_INCIDENTS' &&
              param.metricId !== 'DISTRIBUTION_NUMBER_OF_FATALITIES' &&
              param.metricId !== 'DISTRIBUTION_UNSAFE_ACT' &&
              param.metricId !== 'DISTRIBUTION_UNSAFE_CONDITION' &&
              param.metricId !== 'DISTRIBUTION_NEAR_MISS'
            "
            @mouseenter="showTooltipArc"
            @mouseleave="hideTooltipArc"
            class="d-inline-flex align-items-center me-2 tooltip-container"
            :class="
              param.achievementStatus === 'UP' ? 'badge_green' : 'badge_red'
            "
          >
            <div v-if="visibleArc" class="tooltip-content">
              <span>Achievement</span>
            </div>
            <IconSvg
              :color="param.achievementStatus === 'UP' ? 'green' : 'red'"
              :type="
                param.achievementStatus === 'UP' ? 'arrow_up' : 'arrow_down'
              "
            />
            <div
              class="data_detil"
              v-bind:style="
                param.achievementStatus === 'UP'
                  ? 'color: green;'
                  : 'color: red;'
              "
            >
              {{ param.achievement !== null ? param.achievement : "-" }}
            </div>
          </div>
          <div
            @mouseenter="showTooltip"
            @mouseleave="hideTooltip"
            class="d-inline-flex align-items-center tooltip-container"
            :class="param.trendStatus === 'UP' ? 'badge_green' : 'badge_red'"
          >
            <div
              style="left: 60px !important"
              v-if="visible"
              class="tooltip-content"
            >
              <span>Trend</span>
            </div>
            <IconSvg
              :color="param.trendStatus === 'UP' ? 'green' : 'red'"
              :type="param.trendStatus === 'UP' ? 'chart_up' : 'chart_down'"
            />
            <div
              class="data_detil"
              v-bind:style="
                param.trendStatus === 'UP' ? 'color: green;' : 'color: red;'
              "
            >
              {{ param.trend !== null ? param.trend : "-" }}
            </div>
          </div>
        </div>
        <!-- <div
          v-if="
            param.metricId !== 'DISTRIBUTION_ELECTRICITY_SOLD' &&
            param.metricId !== 'DISTRIBUTION_DAFTAR_TUNGGU' &&
            param.metricId !== 'DISTRIBUTION_NUMBER_OF_FATALITIES' &&
            param.metricId !== 'DISTRIBUTION_UNSAFE_ACT' &&
            param.metricId !== 'DISTRIBUTION_UNSAFE_CONDITION' &&
            param.metricId !== 'DISTRIBUTION_NEAR_MISS' &&
            !param.metricId.includes('NETWORK')
          "
          :style="
            param.metricId === 'DISTRIBUTION_PENURUNAN_ADUAN_PLNMOBILE'
              ? 'margin-top:-15px'
              : ''
          "
          style="text-align: right"
        >
          <button
            @mouseover="hover"
            @mouseleave="afterHover"
            :class="{ hovered: isHovered }"
            class="naked_button"
            @click="onShowModalDetail(param)"
          >
            <img :src="imgDetail" />
          </button>
        </div> -->
        <div
          v-if="!param.metricId.includes('NETWORK')"
          :style="
            param.metricId ===
              'DISTRIBUTION_PENURUNAN_RATING_NEGATIF_PLNMOBILE' ||
            param.metricId === 'DISTRIBUTION_PENURUNAN_ADUAN_PLNMOBILE' ||
            param.metricId === 'DISTRIBUTION_NUMBER_OF_INCIDENTS' ||
            param.metricId === 'DISTRIBUTION_UNSAFE_CONDITION'
              ? 'margin-top:-15px'
              : param.metricId === 'DISTRIBUTION_DAFTAR_TUNGGU'
              ? 'margin-top:-10px'
              : ''
          "
          style="text-align: right"
        >
          <img
            @click="onShowModalDetail(param)"
            @mouseover="hover"
            @mouseleave="afterHover"
            :class="{ hovered: isHovered }"
            class="naked_button"
            style="cursor: pointer"
            :src="imgDetail"
          />
          <!-- <button
            @mouseover="hover"
            @mouseleave="afterHover"
            :class="{ hovered: isHovered }"
            class="naked_button"
            @click="onShowModalDetail(param)"
          >
            <img :src="imgDetail" />
          </button> -->
        </div>
      </div>
      <div
        style="margin-top: -8px"
        class="d-inline-flex align-items-center me-2 justify-content-between"
      >
        <div style="color: #7a7a7a; font-size: small">
          Period: {{ convertToMMMYYYY(param.month, param.year) }}
        </div>
        <div
          v-if="param.frequency !== null"
          style="
            color: rgb(235 235 235);
            font-size: small;
            background-color: #00a3e9;
            padding: 1%;
            border-radius: 5px;
          "
          :style="
            param.metricId === 'DISTRIBUTION_PENURUNAN_ADUAN_PLNMOBILE'
              ? 'margin-top: -4%'
              : ''
          "
        >
          {{ param.frequency }}
        </div>
      </div>
    </div>
    <ModalDistributionDetailVue
      :showModal="modalDetail.show"
      :dataDetail="dataDetail"
      :titleDetail="titleDetail"
      @closeModal="onCloseModalDetail"
    ></ModalDistributionDetailVue>
  </div>
</template>

<script>
import moment from "moment";

import IconSvg from "@/components/IconSvg.vue";
import { formattedNumber } from "@/utils/helper";
import DistributionService from "@/services/distribution/distribution";
import ModalDistributionDetailVue from "../modals/ModalDistributionDetail.vue";

const apiDistribution = DistributionService.build();
export default {
  components: {
    IconSvg,
    ModalDistributionDetailVue,
  },
  props: {
    param: {
      type: Object,
      required: true,
    },
    height: {
      type: Number,
      required: false,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      visible: false,
      visibleArc: false,
      isHovered: false,
      dataDetail: [],
      imgDetail: require("@/assets/images/a/chart_icon.svg"),
      titleDetail: "",
      modalDetail: {
        show: false,
        load: false,
      },
    };
  },
  mounted() {},
  methods: {
    convertToMMMYYYY(month, year) {
      if (month !== null) {
        return moment(`${month}, ${year}`, "M, YYYY").format("MMM, YYYY");
      } else {
        return "-";
      }
    },
    showTooltip() {
      this.visible = true;
    },
    hideTooltip() {
      this.visible = false;
    },
    showTooltipArc() {
      this.visibleArc = true;
    },
    hideTooltipArc() {
      this.visibleArc = false;
    },
    hover() {
      this.isHovered = true;
      this.imgDetail = require("@/assets/images/a/chart_icon_active.svg");
    },
    afterHover() {
      this.imgDetail = require("@/assets/images/a/chart_icon.svg");
    },
    detail(x) {},
    unit(x) {
      return x !== null ? `(${x})` : "";
    },
    unitShow(x) {
      return x === "%" ? x : "";
    },
    onCloseModalDetail(value) {
      this.modalDetail.show = value;
    },
    onShowModalDetail(param) {
      this.modalDetail.show = true;
      this.dataDetail = param;
    },
    formattedNumber,
  },
};
</script>

<style scoped>
.selected {
  background-color: #ecf9ff;
  border: 1px solid #00a3e9;
}
.hovered {
  transform: scale(1.1); /* Example of hover effect */
  /* Add any other styles you want to apply on hover */
}
</style>
